import React from "react";
import styles from "./OrgInviteBulkErrors.module.css";

interface OrgInviteBulkErrorsProps {
  errors: string[];
}

export function OrgInviteBulkErrors({ errors }: OrgInviteBulkErrorsProps) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className={styles.errorContainer}>
      <h4>Parsing Errors:</h4>
      <ul>
        {errors.map((error, index) => (
          <li key={index} className={styles.error}>
            {error}
          </li>
        ))}
      </ul>
    </div>
  );
}
